// extracted by mini-css-extract-plugin
module.exports = {"expand":"FJResourceExpand_expand__126FF","arrow":"FJResourceExpand_arrow__HDSB1","active":"FJResourceExpand_active__MGoz0"};